import {Component, Input, Output, EventEmitter, inject} from '@angular/core';
import { UnitType } from 'src/api';
import { ConceptInputComponent } from '../../../forms/input/concept-input.component';
import { IconType, Icons } from '@ansys-internal/awc-angular/icons';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@ansys-internal/awc-angular/buttons';
import { transmissionComponentType } from '../../../../../shared/models/concept-components/transmission.model';
import { FeatureFlagsEnum } from '../../../../../shared/enums/feature-flags.enum';
import { CommonModule } from '@angular/common';
import { FeatureFlagModule } from '../../../../../shared/modules/feature-flag.module';
import { defaultPartsMap } from "../../../../dialogs/add-part/lib/default-parts-map";
import { PartType } from "../../../../../shared/enums";
import {ConceptUnitService} from "../../../../../shared/services/unit.service";
import {InputType} from "@ansys-internal/awc-angular/forms";
export type SetPart =
  | [string, string, string, number]
  | [string, string, string];

@Component({
    selector: 'app-transmission-inputs',
    templateUrl: './transmission.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [
        ConceptInputComponent,
        ButtonComponent,
        CommonModule,
        FeatureFlagModule,
    ]
})
export class TransmissionComponent {
  @Input() part!: transmissionComponentType;
  @Input() update!: boolean;
  @Input() readonly!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  @Output() forceUpdate: EventEmitter<string> = new EventEmitter<string>();
  protected addIcon: IconType = { icon: Icons.ADD };
  protected delIcon: IconType = { icon: Icons.DELETE };
  protected alttype: ButtonType = ButtonType.SECONDARY;
  protected smallsize: ButtonSize = ButtonSize.SMALL;
  protected normalsize: ButtonSize = ButtonSize.LARGE;
  protected UnitType = UnitType;
  protected InputTypes = InputType;
  protected readonly FeatureFlagsEnum = FeatureFlagsEnum;
  protected unitService = inject(ConceptUnitService);

  /**
   * Add a new gear ratio and efficiency to the part
   */
  protected addGear(): void {
    const defaultValues = (this.part.default_values) ? this.part.default_values : (defaultPartsMap.get(PartType.TRANSMISSION) as any)?.default_values;

    if (defaultValues?.gear_ratios) {
      this.part.gear_ratios?.push(defaultValues.gear_ratios[0]);
    }
    if (defaultValues?.headline_efficiencies) {
      this.part.headline_efficiencies?.push(
        defaultValues?.headline_efficiencies[0]
      );
    }
    if (defaultValues?.friction_ratios) {
      this.part.friction_ratios?.push(
        defaultValues?.friction_ratios[0]
      );
    }
    if (defaultValues?.static_drags) {
      this.part.static_drags?.push(defaultValues?.static_drags[0]);
    }

    this.forceUpdate.emit('gear_ratios');
  }

  protected removeGear(index: number): void {
    this.part.gear_ratios?.splice(index, 1);
    this.part.headline_efficiencies?.splice(index, 1);
    this.part.friction_ratios?.splice(index, 1);
    this.part.static_drags?.splice(index, 1);

    if (this.part.gear_ratios && this.part.gear_ratios.length <= 1) {
      this.part.shift_time = 0;
    }
    this.forceUpdate.emit('gear_ratios');
  }
}
